import React from "react";
import HomeBanner from '../components/homeBanner/homeBanner';
import KtempleNav from '../components/ktempleNav/ktempleNav';
import Kevents from "../components/kevents/kevents";
import Footer from '../components/Footer/Footer';
import VisitingTemple from '../components/VisitingTemple/VisitingTemple';
import CommonEvent from "../components/kcommonevent/kcommonevent";
import DocumentMeta from 'react-document-meta';

function KrishnaEvents() {
 const meta = {
    title: "Events - Radha Madhav Krishna Temple Milwaukee",
    description: "Events at Krishna Temple Milwaukee WI.",
    keywords: "Events, Radha Madhav Krishna Temple, Milwaukee, Programs, Activities",
    canonical: "https://www.krishnatemplemilwaukee.org/krishna-temple-events",
    meta: {
      charset: 'utf-8',
      name: {
        keywords: "Events, Radha, Madhav, Krishna, Temple, Milwaukee,community"
      }
    },
    og: {
      title: "Events - Radha Madhav Krishna Temple Milwaukee",
      description: "Events at Krishna Temple Milwaukee WI.",
      url: "https://www.krishnatemplemilwaukee.org/krishna-temple-events",
      image: "/images/temple-event.jpg"
    }
  };
  return (
    <div>
      <DocumentMeta {...meta} />
      <KtempleNav />
      <HomeBanner />
      <Kevents />
      <CommonEvent />
      <VisitingTemple />
      <Footer />
    </div>
  )
}

export default KrishnaEvents